import { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import './ibanById.css'
import { useTranslation } from 'react-i18next';
import AuthContext from 'contexte/AuthContext';
import { approveIban, fetchIbanDetails, rejectIban } from 'services/ibanServices';
import Notification from 'components/notifications/Notification';
import { launchSuccess, launchError } from 'components/notifications'
import { useNavigate } from 'react-router-dom';
import { formatIBAN } from 'utils/iban';
import { formatPhoneNumber } from 'utils/numbers';
// import { ToastContainer, toast } from 'react-toastify';


const IbanById = () => {

    const { user } = useContext(AuthContext)
    const { t } = useTranslation()

    const navigate = useNavigate();
    const { id } = useParams()
    const [loading, setLoading] = useState(true)
    const [ibanDetails, setIbanDetails] = useState({})
    const [reason, setReason] = useState(null);
    const [fileIsImage, setFileIsImage] = useState(true);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchIbanDetails(user, id)
                setIbanDetails(data)
                setLoading(false)
            } catch (e) {
                console.error(e)
            }
        }

        fetchData()
    }, [])


    const approve = async () => {
        try {
            await approveIban(user, ibanDetails.bank_account_id)
            navigate('/finances/iban')
            launchSuccess(t('notifications.payouts.ibans.approve.success'));
        } catch (error) {
            launchError(t('notifications.payouts.ibans.approve.error'))
        }
    }

    const reject = async () => {
        try {
            await rejectIban(user, ibanDetails.bank_account_id, reason)
            navigate('/finances/iban')
            launchSuccess(t('notifications.payouts.ibans.reject.success'));
        } catch (error) {
            console.log('error reject catch');
            launchError(t('notifications.payouts.ibans.reject.error'))
        }
    }

    return (
        <DashboardLayout page={`${t("pages_name.ibans")} / ${id}`}>
            <div className='w-full'>
                {
                    !loading ? (
                        <div className='w-full'>
                            <Notification />
                            <div className='ibanById_header'>
                                <h2 className='ibanById_title'>Détail de l'iban</h2>
                                <p className='ibanById_title'>{ibanDetails.status}</p>
                            </div>
                            <div className='ibanById_secion'>
                                <div className='ibanById_userInformation'>
                                    <div className='ibanById_userInformation_profil'>
                                        <div className='ibanById_userInformation_profil_img' style={{ backgroundImage: `url(${process.env.REACT_APP_CDN_URL}/usr/pic/${ibanDetails.client_pic})` }} />
                                        <p>{ibanDetails.client_firstName + " " + ibanDetails.client_lastName}<strong>{ibanDetails.is_deleted ? ' (Compte supprimé)' : ''}</strong></p>
                                    </div>
                                    <div className='ibanById_userInformation_infos'>
                                        <p><strong>Email</strong> : {ibanDetails.client_email}</p>
                                        <p><strong>Téléphone</strong> : {formatPhoneNumber(ibanDetails.client_phone)}</p>
                                    </div>
                                </div>

                                <div className='ibanById_userInformation'>
                                    <div className='ibanById_ibanInformation_iban'>
                                        <p><strong>Nom de la banque</strong> : {ibanDetails.bank_name}</p>
                                        <p><strong>Nom associé</strong> : {ibanDetails.iban_associated_name}</p>
                                        <p><strong>Nom OCR</strong> : {ibanDetails.ocr_full_name || "N/A"} {ibanDetails.iban_associated_name === ibanDetails.ocr_full_name ? (<span className='ocr_confirmed'>Confirmé</span>) : (<span className='ocr_not_confirmed'>Différent</span>)}</p>
                                    </div>
                                    <div className='ibanById_ibanInformation_ocr'>
                                        <p><strong>Création de l'iban</strong> : {ibanDetails.created_at}</p>
                                        <p><strong>IBAN</strong> : {formatIBAN(ibanDetails.iban)}</p>
                                        <p><strong>IS DELETED</strong> : {ibanDetails.is_deleted}</p>
                                        <p className='ocr_validation'><strong>IBAN OCR OCR</strong> : {ibanDetails.ocr_iban || "N/A"} {ibanDetails.iban === ibanDetails.ocr_iban ? (<span className='ocr_confirmed'>Confirmé</span>) : (<span className='ocr_not_confirmed'>Différent</span>)}</p>
                                    </div>
                                </div>

                                <div className='ibanById_userInformation iban_container_img'>
                                    {fileIsImage
                                        ? <img src={`${process.env.REACT_APP_CDN_URL}/${ibanDetails.file_link}`} alt="" className='iban_file' onError={() => setFileIsImage(false)} />
                                        : <iframe src={`${process.env.REACT_APP_CDN_URL}/${ibanDetails.file_link}`} className='iban_file_embed' title='iban document' />
                                    }
                                </div>

                                <div className='ibanById_userInformation iban_refusal_reason'>
                                    <select
                                        id="reasons_dropdown"
                                        onChange={(e) => setReason(e.target.value)}>
                                        <option value="">Sélectionner une raison de refus</option>
                                        <option value="name_not_match">Le nom ne correspond pas</option>
                                        <option value="picture_not_match">L'image de correspond pas</option>
                                    </select>
                                </div>

                                <div className='ibanById_button_container'>
                                    <button className='ibanById_refused'
                                        disabled={!reason}
                                        onClick={() => reject()}>Refuser l'IBAN</button>
                                    <button className='ibanById_accepted'
                                        onClick={() => approve()}
                                        disabled={ibanDetails?.is_deleted}
                                    >Accepter l'IBAN</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>Loading...</div>
                    )
                }
            </div>
        </DashboardLayout>
    )
}

export default IbanById